// List of numbers that should bypass validation
const BYPASS_NUMBERS = [
  "+447700900000",
  "+447700900001",
  "+447700900002",
  "+447700900003",
  "+447700900006",
  "+447700900010",
  "+447700900015",
];

export const normalizeNumber = (value: string): string => {
  return value.replace(/\s+/g, "");
};

export const isDummyNumber = (value: string): boolean => {
  const normalized = normalizeNumber(value);

  // Direct match (already has +44)
  return BYPASS_NUMBERS.includes(normalized);
};